<template>
    <div class="saved-search-new-escorts-wrapper" v-if="showComponent">

        <div class="saved-search-new-escorts-header">
            <span>{{ translate.home.newSavedSearchEscorts }}</span>
        </div>

        <div class="row profile-block-wrap">

            <template v-for="user in savedSearchNewEscorts">
                <regular-escort v-if="!isGoldUser(user)"
                                :key="'savedSearchNewEscorts-' + user.id"
                                :userProp="user"
                                @onDistanceClick="onDistanceClick"
                                @onUserClick="setTrackingSearchResultType('newalert'); onUserClick(user);"
                ></regular-escort>

                <premium-escort v-if="isGoldUser(user)"
                                :key="'savedSearchNewEscorts-' + user.id"
                                :userProp="user"
                                @onDistanceClick="onDistanceClick"
                                @onUserClick="setTrackingSearchResultType('newalert'); onUserClick(user);"
                ></premium-escort>
            </template>
        </div>

        <div class="saved-search-new-escorts-footer mt-3 mt-md-1">
            <span>{{ translate.home.allOtherEscorts }}</span>
        </div>

    </div>
</template>

<script>

import RegularEscortViewComponent from "@/components/search/partials/RegularEscortViewComponent";
import PremiumEscortViewComponent from "@/components/search/partials/PremiumEscortViewComponent";
import userMixin from "@/components/mixins/userMixin";
import urlMixin from "@/components/mixins/url-mixin";
import xtrackingMixin from '@/components/mixins/xtrackingMixin';

const data = () => {
    return {
        showNoscript: true,
        showComponent: true,
    }
}

function created() {
    this.hideComponentIfNoData(this.savedSearchNewEscorts);
}

function hideComponentIfNoData(escorts) {
    this.showComponent = (_.get(escorts, 'length', false)) > 0;
}

function onDistanceClick() {
    this.$emit('onDistanceClick');
}

function onUserClick(user) {
    this.setSearchDataToLocalStorage();
    if (!_.isEqual(this.$route.fullPath, user.profile_path)) {
        this.$router.push({path: user.profile_path});
    }
}

export default {
    data,
    created,
    computed: {
        ...mapState(['savedSearchNewEscorts', 'translate']),
    },
    watch: {
        savedSearchNewEscorts(value) {
            this.hideComponentIfNoData(value);
        }
    },
    mixins: [
        userMixin,
        urlMixin,
        xtrackingMixin,
    ],
    components: {
        'regular-escort': RegularEscortViewComponent,
        'premium-escort': PremiumEscortViewComponent,
    },
    methods: {
        hideComponentIfNoData,
        onDistanceClick,
        onUserClick,
    }
}
</script>

